"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var Modal_meta_1 = require("./Modal.meta");
var mobx_1 = require("mobx");
var react_dom_1 = require("react-dom");
var ModalHelper_1 = require("./ModalHelper");
var Translate_1 = __importDefault(require("../Translate"));
var ModalWrapper_1 = __importDefault(require("./styledComponents/ModalWrapper"));
var ClickLayer_1 = __importDefault(require("../ClickLayer"));
var ModalOpenButton_1 = __importDefault(require("./styledComponents/ModalOpenButton"));
var ModalOpenIcon_1 = __importDefault(require("./styledComponents/ModalOpenIcon"));
var ModalActions_1 = __importDefault(require("./styledComponents/ModalActions"));
var ModalFooter_1 = __importDefault(require("./styledComponents/ModalFooter"));
var ModalBody_1 = __importDefault(require("./styledComponents/ModalBody"));
var ModalHead_1 = __importDefault(require("./styledComponents/ModalHead"));
var ModalCloseButton_1 = __importDefault(require("./styledComponents/ModalCloseButton"));
var ModalCloseIcon_1 = __importDefault(require("./styledComponents/ModalCloseIcon"));
var ModalTitleBar_1 = __importDefault(require("./styledComponents/ModalTitleBar"));
var ModalTitle_1 = __importDefault(require("./styledComponents/ModalTitle"));
var ModalAction_1 = __importDefault(require("./styledComponents/ModalAction"));
var ModalActionClose_1 = __importDefault(require("./styledComponents/ModalActionClose"));
var translations_1 = require("../../../shared/translations");
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Modal_meta_1.MODAL_CATEGORY_KEY;
        _this.componentKey = Modal_meta_1.MODAL_COMPONENT_KEY;
        _this.showModal = false;
        /**
         * Used by the static ModalHelper class
         *
         * @readonly
         */
        _this.handleClose = function () {
            var onClose = _this.props.onClose;
            _this.showModal = false;
            ModalHelper_1.ModalHelper.removeActiveModal(_this);
            if (onClose) {
                onClose();
            }
        };
        _this.handleOpen = function () {
            _this.showModal = true;
            ModalHelper_1.ModalHelper.addActiveModal(_this);
        };
        _this.titleId = "modal-" + props.modalId + "-title-" + ksys_app_template_1.utils.guid.generateGuid();
        _this.headerId = "modal-" + props.modalId + "-header-" + ksys_app_template_1.utils.guid.generateGuid();
        if (props.isOpen !== undefined) {
            _this.handleIsOpenInitialization(props.isOpen);
        }
        ModalHelper_1.ModalHelper.init();
        return _this;
    }
    Object.defineProperty(Modal.prototype, "isOpen", {
        get: function () {
            var isOpen = this.props.isOpen;
            if (isOpen !== undefined) {
                return isOpen;
            }
            return this.showModal;
        },
        enumerable: true,
        configurable: true
    });
    Modal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) {
            this.handleIsOpenInitialization(this.props.isOpen);
        }
    };
    Modal.prototype.componentDidMount = function () {
        var modalId = this.props.modalId;
        if (modalId) {
            this.modalNode = document.getElementById(modalId);
        }
    };
    Modal.prototype.handleIsOpenInitialization = function (isOpen) {
        if (isOpen === void 0) { isOpen = false; }
        isOpen ? this.handleOpen() : this.handleClose();
    };
    Object.defineProperty(Modal.prototype, "titleBar", {
        /**
         * Modal Title which is referenced by screen readers when the modal is opened.
         * Additionally the close button is display here
         *
         * @readonly
         */
        get: function () {
            var title = this.props.title;
            return (react_1.default.createElement(ModalTitleBar_1.default, null,
                react_1.default.createElement(ModalTitle_1.default, { id: this.titleId },
                    react_1.default.createElement(Translate_1.default, null, title)),
                this.titleBarCloseButton));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "titleBarCloseButton", {
        get: function () {
            var _this = this;
            var _a = this.props, title = _a.title, closeButtonProps = _a.closeButtonProps;
            var buttonProps = this.getModalButtonProps(closeButtonProps, {
                iconProps: {
                    asset: 'base.modal.close',
                },
                iconPosition: 'right',
                disabled: false,
            });
            if (buttonProps.disabled) {
                return null;
            }
            var CloseIcon = (react_1.default.createElement(ModalCloseIcon_1.default, __assign({}, buttonProps.iconProps, { "aria-hidden": true })));
            return (react_1.default.createElement(ModalCloseButton_1.default, { onClick: function (e) { return _this.handleClose(); }, "aria-label": translations_1.translate(buttonProps.text || "Close " + title + " dialog") },
                buttonProps.iconPosition === 'left' && CloseIcon,
                buttonProps.text && (react_1.default.createElement(Translate_1.default, null, buttonProps.text)),
                buttonProps.iconPosition === 'right' && CloseIcon));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "headerContent", {
        get: function () {
            var headerContent = this.props.headerContent;
            return (headerContent && (react_1.default.createElement(ModalHead_1.default, { id: this.headerId }, headerContent)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "bodyContent", {
        get: function () {
            var _a = this.props, children = _a.children, bodyContent = _a.bodyContent;
            return (react_1.default.createElement(ModalBody_1.default, null, bodyContent || children));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "footerContent", {
        get: function () {
            var footerContent = this.props.footerContent;
            return (footerContent && (react_1.default.createElement(ModalFooter_1.default, null, footerContent)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "actions", {
        /**
         * Typical modal action buttons that appear below the footer content
         *
         * @readonly
         */
        get: function () {
            var _this = this;
            var actions = this.props.actions;
            if (actions && actions.length > 0) {
                return (react_1.default.createElement(ModalActions_1.default, null, actions.map(function (modalAction, modalActionIndex) {
                    var ModalActionButton = modalAction.type === 'custom'
                        ? ModalAction_1.default
                        : ModalActionClose_1.default;
                    return (react_1.default.createElement(ModalActionButton, { key: "action-" + modalActionIndex + "-" + modalAction.id, onClick: function (e) {
                            switch (modalAction.type) {
                                case 'close':
                                    _this.handleClose();
                                    break;
                                case 'closeAndCustom':
                                    _this.handleClose();
                                default:
                                    if (modalAction.onAction) {
                                        modalAction.onAction(modalAction.id);
                                    }
                                    break;
                            }
                        } },
                        react_1.default.createElement(Translate_1.default, null, modalAction.label)));
                })));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "openButton", {
        /**
         * The button responsible for opening the modal
         *
         * @readonly
         */
        get: function () {
            var _this = this;
            var _a = this.props, title = _a.title, openButtonProps = _a.openButtonProps;
            var buttonProps = this.getModalButtonProps(openButtonProps, {
                text: "Open " + title + " dialog",
                iconProps: {
                    asset: !this.isOpen
                        ? 'base.modal.openIcon'
                        : 'base.modal.openedIcon',
                },
                iconPosition: 'right',
                disabled: false,
            });
            if (buttonProps.disabled) {
                return null;
            }
            var ExpandIcon = (react_1.default.createElement(ModalOpenIcon_1.default, __assign({}, buttonProps.iconProps, { "aria-hidden": 'true' })));
            return (react_1.default.createElement(ModalOpenButton_1.default, { onClick: function (e) { return _this.handleOpen(); } },
                buttonProps.iconPosition === 'left' && ExpandIcon,
                react_1.default.createElement(Translate_1.default, null, buttonProps.text),
                buttonProps.iconPosition === 'right' && ExpandIcon));
        },
        enumerable: true,
        configurable: true
    });
    Modal.prototype.getModalButtonProps = function (props, defaultProps) {
        if (props) {
            return __assign(__assign({}, defaultProps), props);
        }
        return defaultProps;
    };
    Modal.prototype.renderModal = function () {
        var _this = this;
        var className = this.props.className;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ModalWrapper_1.default, { className: className, role: "dialog", "aria-modal": "true", "aria-labelledby": this.titleId, "aria-describedby": this.headerContent && this.headerId },
                this.titleBar,
                this.headerContent,
                this.bodyContent,
                this.footerContent,
                this.actions),
            react_1.default.createElement(ClickLayer_1.default, { onClick: function () { return _this.handleClose(); } }));
    };
    Modal.prototype.renderModalPortal = function () {
        return react_dom_1.createPortal(this.renderModal(), this.modalNode);
    };
    Modal.prototype.render = function () {
        var modal = this.modalNode ? this.renderModalPortal() : this.renderModal();
        return react_1.default.createElement(react_1.default.Fragment, null,
            this.isOpen && modal,
            this.openButton);
    };
    __decorate([
        mobx_1.observable
    ], Modal.prototype, "showModal", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Modal.prototype, "modalNode", void 0);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "isOpen", null);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "titleBar", null);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "titleBarCloseButton", null);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "headerContent", null);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "bodyContent", null);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "footerContent", null);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "actions", null);
    __decorate([
        mobx_1.computed
    ], Modal.prototype, "openButton", null);
    __decorate([
        mobx_1.action
    ], Modal.prototype, "handleClose", void 0);
    __decorate([
        mobx_1.action
    ], Modal.prototype, "handleOpen", void 0);
    Modal = __decorate([
        mobx_react_1.observer
    ], Modal);
    return Modal;
}(shared_1.ComponentBase));
exports.Modal = Modal;
exports.default = shared_1.InjectedStyledComponent(Modal, Modal_meta_1.MODAL_CATEGORY_KEY, Modal_meta_1.MODAL_COMPONENT_KEY);
